'use client';

import Image from 'next/image';
import { MODAL_TYPES, useModal } from './ModalProvider';

export default function CompanyUSPModalWrapper({ isOpen, onClose, item }) {
  const { modalUtils, getCloseButton } = useModal();

  return modalUtils.createModalWrapper({
    modalType: MODAL_TYPES.companyUSP,
    isOpen,
    onClose,
    containerClassName: modalUtils.containerPresets.standard.basic,
    children: (
      <>
        {getCloseButton(MODAL_TYPES.companyUSP, onClose)}
        <div className="pr-8">
          <Image
            src={`${item.modal_icon.url}?format=pjpg&auto=webp&disable=upscale`}
            alt={item.modal_icon.title.replace(/\.[^/.]+$/, '')}
            width={60}
            height={60}
            className="mb-4 sm:mb-6"
          />
          <h3 className="sh9 mb-3 block text-black sm:mb-4">{item.title}</h3>
          <p className="body-r leading-relaxed text-gray-700">
            {item.description}
          </p>
        </div>
      </>
    )
  });
}
